<template>
  <div :menu-fix="true">
    <div class="wrapper">
      <breadcrumb
        :crumbs="[
          $t('menu.reports'),
          $t('reports.omsWholesaleCustomerRanking'),
        ]"
      >
      </breadcrumb>
    </div>
    <div class="search">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
        label-width="130px"
      >
        <el-form-item
          :label="$t('menu.bargains') + $t('order.confirmAt')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('order.confirmAt')]),
              trigger: 'blur',
            },
          ]"
        >
          <date-range
            v-model="searchForm"
            type="datetime"
            field="confirmAt"
            :start-placeholder="$t('text.startAt')"
            :end-placeholder="$t('text.endAt')"
          />
        </el-form-item>
        <br />
        <el-form-item
          :label="$t('salesTarget.userName')"
          v-if="users.length != 0"
        >
          <el-checkbox-group v-model="searchForm.ownerIds">
            <el-checkbox v-for="user of users" :key="user.id" :label="user.id">
              <span v-if="user.voidAt != null" class="deleted">
                {{ user.name }}
              </span>
              <span v-else>{{ user.name }}</span>
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <br v-if="users.length != 0" />
        <el-form-item :label="$t('menu.shops')">
          <el-checkbox-group v-model="searchForm.shopIds">
            <el-checkbox
              v-for="(shop, index) of shops"
              :key="index"
              :label="shop.id"
              >{{ shop.name }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <br />
        <el-form-item :label="'排名方式'">
          <el-radio-group v-model="searchForm.rankBy">
            <el-radio label="salesAmount"> 按成交额 </el-radio>
            <el-radio label="totalQty"> 按订单量 </el-radio>
            <el-radio label="productQty"> 按产品数 </el-radio>
          </el-radio-group>
        </el-form-item>
        <br />
        <el-form-item :label="' '">
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
            >{{ $t("text.search") }}</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-button type="default" size="mini" @click="download">
              {{ $t("action.download") }}
            </el-button>
          </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="records"
        :loading="loading"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column type="seq" :title="'名次'" width="80" />
        <vxe-table-column
          field="customerName"
          :title="$t('menu.customers')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.customerName }}
          </template>
        </vxe-table-column>
        <vxe-table-column field="totalQty" :title="'订单量'" min-width="80" />
        <vxe-table-column field="productQty" :title="'产品数'" min-width="80" />
        <vxe-table-column
          field="salesAmount"
          :title="$t('bargain.amount')"
          min-width="110"
        >
          <template v-slot="{ row }">
            {{ row.salesAmount | currency }}
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips"></div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { page, table } from "@/utils/mixins.js";
import DateRange from "@/components/DateRange";
import User from "@/api/user";
import Shop from "@/api/shop";
import Bargain from "@/api/bargain";

export default {
  mixins: [page, table.pager, table.search],
  components: { DateRange },
  data() {
    return {
      searchForm: {
        confirmAtStartAt: null,
        confirmAtEndAt: null,
        shopIds: [],
        ownerIds: [],
        rankBy: "salesAmount",
      },
      users: [],
      shops: [],
      //
      records: [],
      totals: [],
      loading: false,
    };
  },

  created() {
    const self = this;
    axios.all([Shop.findByTenantId(), User.findByTenantId()]).then(
      axios.spread(function (shops, users) {
        if (shops.status == 200) {
          self.shops = shops.data;
        } else {
          self.sysError();
        }
        if (users.status == 200) {
          self.users = users.data.filter(
            (u) => (u.voidAt == null && u.authorize == true) || u.voidAt != null
          );
          // if (self.Permit.currentUser().admin === true) {
          //   self.users = allUsers;
          // } else {
          //   self.users = allUsers.filter((u) =>
          //     JSON.parse(self.Permit.currentUser().manageUsers).includes(u.id)
          //   );
          // }
        } else {
          self.sysError();
        }
      })
    );
  },
  methods: {
    //
    download() {
      const self = this;
      if (self.searchForm.confirmAtStartAt == null) {
        this.$message({
          message: self.$t("rules.select", [
            self.$t("menu.bargains") + self.$t("order.confirmAt"),
          ]),
          type: "warning",
        });
        return;
      }
      if (self.records.length == 0) {
        this.$message({
          message: self.$t("text.noData"),
          type: "warning",
        });
        return;
      }
      Bargain.wholesaleCustomerRankingReportExportExcel(
        self.combineParams()
      ).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.downloadPrompt"),
            type: "success",
          });
          self.checkedRows = [];
          self.$eventHub.$emit("emitDownLoad");
        } else {
          self.$message.error(self.$t("prompt.downloadErr"));
        }
      });
    },
    //
    loadData() {
      const self = this;
      if (self.searchForm.confirmAtStartAt == null) {
        this.$message({
          message: self.$t("rules.select", [
            self.$t("menu.bargains") + self.$t("order.confirmAt"),
          ]),
          type: "warning",
        });
        return;
      }
      self.loading = true;
      Bargain.wholesaleCustomerRankingReport(self.combineParams()).then(
        function (res) {
          self.loading = false;
          if (res.status === 200) {
            self.records = res.data.records;
            self.pager.total = res.data.total;
          } else {
            self.sysError();
          }
        }
      );
    },
    //
    changePager(params) {
      this.pager.currentPage = params.currentPage;
      this.pager.pageSize = params.pageSize;
      this.loadData();
    },
    combineParams() {
      let params = {};
      if (this.pager) {
        params.currentPage = this.pager.currentPage;
        params.pageSize = this.pager.pageSize;
      }
      if (this.searchForm) {
        for (let key in this.searchForm) {
          if (
            this.searchForm[key] &&
            JSON.stringify(this.searchForm[key]) != "[]"
          ) {
            params[key] = this.searchForm[key];
          }
        }
      }
      return params;
    },
  },
};
</script>
<style >
.el-form-item__content {
  height: auto !important;
}
</style>